import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import { ErrorBoundary } from './app/components/ErrorBoundary';
import './styles/fonts.css';
import './styles/index.css';

console.log('🚀 Sentlo v10.4.1 - main.tsx loading...');
console.log('✅ React imported');
console.log('✅ ReactDOM imported');
console.log('✅ App imported');
console.log('✅ Styles imported');

// v10.4.1 - MODULE LOADING FIX
// - Fixed "Failed to fetch dynamically imported module" error
// - Improved cache busting and error handling
// v10.4.0 - USER POSTS DISPLAY FIX
// - Fixed issue where new user posts weren't showing
// - Backend sync after post creation
// - Periodic sync every 60 seconds
// v10.1.3 - ERROR HANDLING FIX
// - Fixed "Failed to fetch user profile" error on app load
// - Graceful handling of network errors during profile fetch
// - Profile fetching now silent when backend unavailable
// - All post types show immediately (traffic, fuel, crime, bus, activity)
// - MEGA AGGRESSIVE build config (inlineDynamicImports: true)
// - SafePay Escrow disabled by default (admin must activate)

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('❌ CRITICAL: Root element not found!');
  document.body.innerHTML = '<div style="padding: 20px; color: red;"><h1>Error: Root element not found</h1></div>';
} else {
  console.log('✅ Root element found');
  
  try {
    const root = ReactDOM.createRoot(rootElement);
    console.log('✅ React root created');
    
    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </React.StrictMode>
    );
    console.log('✅ App rendered successfully!');
    console.log('🎯 Sentlo v10.4.1 initialization complete');
  } catch (error) {
    console.error('❌ Error during render:', error);
    rootElement.innerHTML = `
      <div style="padding: 20px; color: red;">
        <h1>Render Error</h1>
        <pre>${String(error)}</pre>
      </div>
    `;
  }
}